function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/builtin/taggedTemplateLiteralLoose.js
// module id = 99
// module chunks = 7011981053767 83246993240447 95715928098905 213534597649335